import { VhcRecordLogService } from 'api/generated';
import { QueryError, formatErrorMessage } from 'features/shared/model';
import { UseMutationOptions, useMutation } from 'react-query';
import { toast } from 'react-toastify';

export type DeleteWheelLabourInput = {
  logId: number;
  itemId: number;
  labourId: number;
};

export const useDeleteWheelLabourMutation = (
  options?: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof VhcRecordLogService.deleteVhcRecordsItemsWheelTyresLabours>>,
      QueryError,
      DeleteWheelLabourInput,
      unknown
    >,
    'mutationFn'
  >
) =>
  useMutation(
    ({ logId, itemId, labourId }: DeleteWheelLabourInput) => {
      return VhcRecordLogService.deleteVhcRecordsItemsWheelTyresLabours(logId, itemId, labourId);
    },
    {
      ...options
    }
  );
